import { useCallback } from 'react';
import { useDispatch } from 'store/hooks';
import {
    setAlgorithmParametersRevisionIndex,
    incrementAlgorithmParametersRevisionIndex,
    decrementAlgorithmParametersRevisionIndex,
} from './actions';

export const useDispatchSetAlgorithmParametersRevisionIndex = () => {
    const dispatch = useDispatch();
    return useCallback(
        (revisionIndex: number) =>
            dispatch(setAlgorithmParametersRevisionIndex(revisionIndex)),
        [dispatch]
    );
};

export const useDispatchIncrementAlgorithmParametersRevisionIndex = () => {
    const dispatch = useDispatch();
    return useCallback(
        () => dispatch(incrementAlgorithmParametersRevisionIndex()),
        [dispatch]
    );
};

export const useDispatchDecrementAlgorithmParametersRevisionIndex = () => {
    const dispatch = useDispatch();
    return useCallback(
        () => dispatch(decrementAlgorithmParametersRevisionIndex()),
        [dispatch]
    );
};
